import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import { Page, Toolbar } from 'react-onsenui'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import DescriptionIcon from '@material-ui/icons/Description'
import { appBar, filters, primaryColor } from '../Styles'
import { dateFormat } from 'helpers'

const InvoicesScreen = props => {
  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>Facturas</Typography>
          </div>
          <div className="right" />
        </Toolbar>
      )}>
      <div className={props.classes.filters}>
        <Grid item container>
          <Grid item xs={12} onClick={props.openInvoicesPeriodModal} className={props.classes.filterPeriod1}>
            <Typography className={props.classes.filterName}>
              Periodo
              <KeyboardArrowDownIcon className={props.classes.icon} />
            </Typography>
            <Typography
              className={props.classes.filterValue}
              dangerouslySetInnerHTML={{ __html: props.invoicesPeriodLabel }}
            />
          </Grid>
        </Grid>
      </div>

      <div className={props.classes.invoices}>
        <Grid container>
          {props.invoices &&
            props.invoices.map(invoice => (
              <Grid
                key={invoice.num}
                item
                xs={12}
                sm={6}
                md={4}
                container
                className={props.classes.invoice}
                onClick={() => props.setSelectedInvoice(invoice.id, invoice.num)}>
                <Grid item xs={2}>
                  <DescriptionIcon className={props.classes.invoiceIcon} />
                </Grid>
                <Grid item xs={10}>
                  <Typography className={props.classes.invoiceTitle}>{invoice.code}</Typography>
                  <Typography className={props.classes.invoiceFarmer}>{invoice.farmer.name}</Typography>
                  <Typography className={props.classes.invoiceTotal}>
                    {invoice.total.toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' €'}
                  </Typography>
                  <Typography className={props.classes.invoiceDate}>{dateFormat(invoice.date)}</Typography>
                </Grid>
              </Grid>
            ))}
        </Grid>
      </div>
    </Page>
  )
}

const styles = {
  appBar,
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  filters,
  filterPeriod1: {
    padding: '5px 0',
    ...filters
  },
  filterPeriod2: {
    padding: '5px 0',
    background: '#8ACA4C',
  },
  icon: {
    fontSize: 20,
    verticalAlign: 'middle',
  },
  filterName: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 300,
    fontSize: 13,
  },
  filterValue: {
    marginTop: -3,
    color: 'white',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 15,
  },
  invoices: {},
  invoice: {
    padding: 10,
    borderRight: '1px solid #DDD',
    borderBottom: '1px solid #DDD',
    cursor: 'pointer',
  },
  invoiceTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: primaryColor,
  },
  invoiceIcon: {
    marginTop: 15,
    fontSize: 55,
    color: primaryColor,
  },
  invoiceFarmer: {
    marginTop: -3,
    fontSize: 15,
  },
  invoiceTotal: {
    marginTop: -2,
    fontSize: 18,
  },
  invoiceDate: {
    marginTop: 2,
    fontSize: 11,
    color: '#777',
  },
}

export default withStyles(styles)(InvoicesScreen)



// WEBPACK FOOTER //
// ./src/screens/InvoicesScreen.js